import Http from '@/Http';
import { Categories, Category, Hierarchy } from '@/types/work/product_category';

export const CATEGORIES_REQUEST = 'work/enterprises/categories/request';
export const GET_CATEGORIES = 'work/enterprises/categories/getCategories';

const state = {
  status: '',
  categories: []
};

const getters = {
  getCategories: (state:any):Array<Category> => state.categories,
  getStructured: (state:any):Array<Hierarchy> => {
    return (new Categories([...state.categories])).getStructured();
  }
};

const actions = {
  request: ({ commit, dispatch }:any, enterprise:number, filter:any = {}) => {
    filter = {
      'filters[order_by]': 'title',
      ...filter
    };
    commit('request');
    (new Http()).request({ url: `enterprise/${enterprise}/products/categories`, params: filter })
      .then((resp:any) => {
        commit('success', resp.data.data);
      })
      .catch(() => {
        // if resp is unauthorized, logout, to
      });
  }
};

const mutations = {
  request: (state:any) => {
    state.status = null;
  },
  success: (state:any, resp:Array<Category>) => {
    state.status = true;
    state.categories = resp;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
